import { render, staticRenderFns } from "./qualificacao-economica.vue?vue&type=template&id=283bbf6c&scoped=true"
import script from "./qualificacao-economica.vue?vue&type=script&lang=js"
export * from "./qualificacao-economica.vue?vue&type=script&lang=js"
import style0 from "./qualificacao-economica.vue?vue&type=style&index=0&id=283bbf6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bbf6c",
  null
  
)

export default component.exports